import config from "../../config";
import { css } from "emotion";
import Image from "../Image";
import Slider from "../Slider";
import Button from "../Button";

const maxDisplayItems = 3;
const styles = {
  mobile: css`
    display: none;
    @media (max-width: 600px) {
      display: block;
    }
  `,
  desktop: css`
    display: block;
    @media (max-width: 600px) {
      display: none;
    }
  `,
  wrapper: css`
    width: 100%;
    padding: 72px 80px;
    text-align: left;
    background: #f9f9fa;
    display: flex;
    @media (max-width: 600px) {
      padding: 40px 0px 40px 12px;
      display: block;
    }
  `,
  title: css`
    font-weight: 600;
    margin-left: 10px;
    margin-bottom: 8px !important;
    color: #323232;
    @media (max-width: 600px) {
      font-size: 18px;
    }
  `,
  container: css`
    max-width: 1062px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  `,
  card: css`
    display: block;
    float: left;
    margin: 12px;
    width: 100%;
    text-align: left;
    max-width: 330px;
    background: #fff;
    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
    border-radius: 3px;
    height: 340px;
    position: relative;
    @media (max-width: 600px) {
      float: none;
      max-width: 260px;
      height: 308px;
      display: inline-block;
    }
  `,
  description: css`
    width: 96%;
    margin: 16px 12px;
    @media (max-width: 600px) {
      width: 240px;
    }
  `,
  eventButton: css`
    text-algin: left;
    text-decoration: none !important;
    color: #323232;
    width: 100%;
  `,
  img: css`
    width: 100%;
    max-width: 100%;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
    height: auto;
    max-height: 165px;
    padding: 0;
  `,
  contents: css`
    color: #5a626c;
    height: 50px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  moreButton: css`
    margin-top: 12px;
    margin-left: 10px;
  `,
  priceContainer: css`
    height: 38px;
    border-top: solid 3px #f9f9fa;
    padding-top: 7px;
    padding-left: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  `,
  priceText: css`
    font-size: 14px;
    font-weight: 600;
    color: #323232;
  `,
  cardTitle: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
    font-size: 18px !important;
    color: #323232;
    @media (max-width: 600px) {
      margin-bottom: 8px;
    }
  `
};

const EventCard = props => {
  const { eventUrl, imageUrl, ticketsPriceStr, item } = props;

  return (
    <div className={styles.card} key={item._id}>
      <a className={styles.eventButton} href={eventUrl}>
        <Image className={styles.img} src={imageUrl} alt={`${item.name}`} />
        <div className={styles.description}>
          <h3 className={styles.cardTitle}>{item.name}</h3>
          <p className={styles.contents}>
            {item.dates[0].display.date}, {item.dates[0].display.time}
            <br />
            {item.location.address}
          </p>
        </div>
        <div className={styles.priceContainer}>
          <p className={styles.priceText}>{ticketsPriceStr}</p>
        </div>
      </a>
    </div>
  );
};

const EventCardList = props => {
  const { moreEvents } = props;

  return (
    <div>
      {moreEvents.map((item, index) => {
        if (index < maxDisplayItems) {
          const eventUrl = `${config("TICKETING_URL")}/${item.slug}`;
          const useOldBannerStyle =
            !item.bannerImage && item.featureImage ? true : false;

          let imageHandleOld = item.socialImage
            ? item.socialImage.url
            : item.featureImage
            ? item.featureImage.url
            : "VbieTVjAQvq5BTkE9vIi";

          let imageHandleNew = item.bannerImage
            ? item.bannerImage.url
            : "VbieTVjAQvq5BTkE9vIi";

          const imageUrl = `https://process.filestackapi.com/resize=h:165,w:330,fit:crop/${
            useOldBannerStyle ? imageHandleOld : imageHandleNew
          }`;
          const ticketsPriceStr = item.settings.ticketPriceRangeDisplay
            ? item.ticketsPriceStr
            : "";
          return (
            <EventCard
              eventUrl={eventUrl}
              imageUrl={imageUrl}
              ticketsPriceStr={ticketsPriceStr}
              item={item}
            />
          );
        }
      })}
    </div>
  );
};

const MoreEvents = props => {
  const { event, title = "More events from this organiser" } = props;
  let moreEvents = event && event.moreEvents ? event.moreEvents : [];
  moreEvents = moreEvents.filter(event => event.public === true);
  if (moreEvents.length < 1) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.mobile}>
          <Slider>
            <EventCardList moreEvents={moreEvents} />
          </Slider>
        </div>
        <div className={styles.desktop}>
          <EventCardList moreEvents={moreEvents} />
        </div>
        <div style={{ clear: "both" }} />
        {moreEvents.length >= maxDisplayItems && (
          <div style={{ marginLeft: 10, marginTop: 12 }}>
            <a
              href={`${config("TICKETING_URL")}/organisers/${
                event.moreEvents[0].organiserId
              }`}
              aria-label="See more button"
            >
              <Button
                type="secondary"
                aria-label="See more button"
                aria-hidden={true}
                tabIndex={-1}
              >
                See more
              </Button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreEvents;



// WEBPACK FOOTER //
// ./components/moreEvents/MoreEvents.js